<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="240px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
    [nzTrigger]="null">
    <div class="sidebar-logo">
      <div class="logo">
        <img src="../../assets/images/logo.svg" alt="logo">
      </div>
      <div class="title" *ngIf="!isCollapsed">
        <div>{{appConfig.title}}</div>
      </div>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <ng-container *ngFor="let menu of menus">
        <li nz-menu-item nzMatchRouter routerLink="{{menu.link}}">
          <i nz-icon nzType="{{menu.icon}}"></i>
          <span>{{menu.text}}</span>
        </li>
      </ng-container>
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </span>
        <div class="app-header-extra">
          <a class="user-controls" nz-dropdown [nzDropdownMenu]="menu">
            <i nz-icon nzType="user"></i>
            {{user.account_name}}
          </a>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <!-- <li nz-menu-item (click)="cp.show()">
                <i nz-icon nzType="edit"></i>
                修改密码
              </li>
              <li nz-menu-divider></li> -->
              <li nz-menu-item (click)="logout()">
                <i nz-icon nzType="logout"></i>
                登出
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
